/* Seasonal snowfall (snippets/snowfall.liquid, Theme settings › Seasonal effects).
   Builds 22 flakes (12 on phones) once, after the load event; CSS transforms do the animation, no per-frame JS. */
(function () {
  if (window.gobiSnowfall) return;
  window.gobiSnowfall = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function build() {
    if (document.querySelector('.gobi-snow')) return;
    var phone = window.innerWidth < 750;
    var count = phone ? 12 : 22;
    var maxSize = phone ? 3.5 : 4;
    var fall = phone ? 14 : 16;
    var root = document.createElement('div');
    root.className = 'gobi-snow';
    root.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < count; i++) {
      var dur = fall * (0.75 + Math.random() * 0.5);
      var size = (1.5 + Math.random() * (maxSize - 1.5)).toFixed(1) + 'px';
      var drop = document.createElement('span');
      drop.className = 'gobi-snow__fall';
      drop.style.left = (Math.random() * 100).toFixed(2) + '%';
      drop.style.animationDuration = dur.toFixed(1) + 's';
      drop.style.animationDelay = (-Math.random() * dur).toFixed(1) + 's';
      var flake = document.createElement('span');
      flake.className = 'gobi-snow__flake';
      flake.style.width = size;
      flake.style.height = size;
      flake.style.opacity = (0.8 * (0.55 + Math.random() * 0.45)).toFixed(2);
      flake.style.animationDuration = (3 + Math.random() * 3).toFixed(1) + 's';
      flake.style.animationDelay = (-Math.random() * 6).toFixed(1) + 's';
      drop.appendChild(flake);
      root.appendChild(drop);
    }
    document.body.appendChild(root);
  }

  function later() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(build, { timeout: 2500 });
    else window.setTimeout(build, 1200);
  }

  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
})();
